import { useMemo } from "react";
import moment from "moment";
import useAuth from "./useAuth";

export default function useMinDate() {
  const { user } = useAuth();
  const { settings } = user.company;

  const minDate = useMemo(() => {
    if (!settings.cut_off || settings.cut_off === "0") {
      return undefined;
    }

    const now = new Date();
    const cutoffHours = parseInt(settings.cut_off, 10);
    const minAllowedTime = new Date(now.getTime() + cutoffHours * 60 * 60 * 1000);

    if (minAllowedTime.getHours() >= 12) {
      const nextDay = new Date(minAllowedTime);
      nextDay.setDate(nextDay.getDate() + 1);
      nextDay.setHours(0, 0, 0, 0);
      return moment(nextDay);
    } else {
      minAllowedTime.setHours(0, 0, 0, 0);
      return moment(minAllowedTime);
    }
  }, [settings.cut_off]);

  return minDate;
}
